import { takeLatest, put, all, call } from 'redux-saga/effects';
import verificationTypes from './verification.types';
import { sendAadharOtp, aadharOtpVerify } from './verification.services';
import {
	sendAadharOtpSuccess,
	sendAadharOtpFailure,
	sendAadharOtpResponseResetChanged,
	aadharOtpVerifyResponseResetChanged,
	aadharOtpVerifySuccess,
	aadharOtpVerifyFailure,
} from './verification.action';
import { encryptData } from '../_common/enode-decode';
import AlertManager from '../../utils/alertManager';
/** *********************  START SEND AADHAR OTP  ******************** */
export function* sendAadharOtpSaga({ payload }: any) {
	try {
		const key = 'sendAadharOTPKey';
		const { companyID, databaseName, memberAadharNumber, generalCompanyID, memberPhoneNumber } =
			payload;
		const jsonData = {
			CompanyID: companyID,
			GeneralCompanyID: generalCompanyID,
			DatabaseName: databaseName,
			MemberAadharNumber: memberAadharNumber,
			MemberPhoneNumber: memberPhoneNumber,
			VerifyDocument: memberAadharNumber,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(sendAadharOtp, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(sendAadharOtpFailure(responseData.data));
		} else {
			yield put(sendAadharOtpSuccess(responseData.data));
		}
	} catch (error) {
		yield put(sendAadharOtpFailure(error));
	}
}

export function* resetSendAadharOtpResponse() {
	yield put(sendAadharOtpResponseResetChanged());
}

export function* onSendAadharOtpDetails() {
	yield takeLatest(verificationTypes.SEND_AADHAR_OTP_START, sendAadharOtpSaga);
}

export function* onSendAadharOtpResponseReset() {
	yield takeLatest(
		verificationTypes.SEND_AADHAR_OTP_RESPONSE_RESET_START,
		resetSendAadharOtpResponse,
	);
}
/** *********************  END SEND AADHAR OTP ******************** */

/** *********************  START AADHAR OTP VERIFY ******************** */
export function* aadharOtpVerifySaga({ payload }: any) {
	try {
		const key = 'verifyAadharOTPKey';
		const {
			companyID,
			databaseName,
			memberID,
			memberPhoneNumber,
			verifyOtp,
			memberAadharNumber,
			userID,
			type,
			generalCompanyID,
			clientID,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			MemberPhoneNumber: memberPhoneNumber,
			OTP: verifyOtp,
			VerifyDocument: memberAadharNumber,
			UserID: userID,
			Type: type,
			GeneralCompanyID: generalCompanyID,
			ClientID: clientID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(aadharOtpVerify, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(aadharOtpVerifyFailure(responseData.data));
		} else {
			yield put(aadharOtpVerifySuccess(responseData.data));
		}
	} catch (error) {
		yield put(aadharOtpVerifyFailure(error));
	}
}

export function* resetAadharOtpVerifyResponse() {
	yield put(aadharOtpVerifyResponseResetChanged());
}

export function* onAadharOtpVerifyDetails() {
	yield takeLatest(verificationTypes.AADHAR_OTP_VERIFY_START, aadharOtpVerifySaga);
}

export function* onAadharOtpVerifyResponseReset() {
	yield takeLatest(
		verificationTypes.AADHAR_OTP_VERIFY_RESPONSE_RESET_START,
		resetAadharOtpVerifyResponse,
	);
}
/** *********************  END AADHAR OTP VERIFY ******************** */

export function* verificationSaga() {
	yield all([
		call(onSendAadharOtpDetails),
		call(onSendAadharOtpResponseReset),
		call(onAadharOtpVerifyDetails),
		call(onAadharOtpVerifyResponseReset),
	]);
}
